import React from "react";

import { useIntl } from "react-intl";

import CustomField from "@mapmycustomers/shared/types/customField/CustomField";
import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";

import TextWithInfo from "@app/component/typography/TextWithInfo";
import FieldType from "@app/scene/settings/component/ManageFields/component/FieldType";
import { getEntityTypeDisplayName } from "@app/util/ui";

import styles from "./FieldDetails.module.scss";

interface Props {
  customField?: CustomField;
  field: SchemaField;
}

const FieldDetails: React.FC<Props> = ({ customField, field }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {intl.formatMessage({
          id: "settings.manageFields.editPane.fieldDetails.title",
          defaultMessage: "Field Details",
          description: "Settings Custom field - Field Details panel title",
        })}
      </div>

      <div className={styles.properties}>
        <div className={styles.name}>
          {intl.formatMessage({
            id: "settings.manageFields.editPane.fieldDetails.object",
            defaultMessage: "Object",
            description: "Settings Custom field - Field Details panel object title",
          })}
        </div>
        <div>
          {getEntityTypeDisplayName(intl, field.entity, { lowercase: false, plural: true })}
        </div>

        <div className={styles.name}>
          {intl.formatMessage({
            id: "settings.manageFields.editPane.fieldDetails.type",
            defaultMessage: "Type",
            description: "Settings Custom field - Field Details panel type title",
          })}
        </div>
        <div>
          <FieldType customField={customField} field={field} />
          {customField?.isCalculated && (
            <div className={styles.calculatedFieldInfo}>
              {intl.formatMessage({
                id: "settings.manageFields.editPane.fieldDetails.calculatedField.info",
                defaultMessage:
                  "Calculated fields display results of equations unique to your org, and their values cannot be edited.",
                description: "Settings Custom field - Field Details panel calculated field info",
              })}
            </div>
          )}
        </div>
        {customField?.isCalculated && (
          <>
            <div className={styles.name}>
              <TextWithInfo
                info={intl.formatMessage({
                  id: "settings.manageFields.editPane.fieldDetails.formula.tooltip",
                  defaultMessage:
                    "Please contact your MMC account manager to request changes to formulas on calculated fields.",
                  description: "Settings Custom field - Field Details panel Formula tooltip",
                })}
                tooltipOverlayClassName={styles.formulaTooltip}
              >
                {intl.formatMessage({
                  id: "settings.manageFields.editPane.fieldDetails.formula",
                  defaultMessage: "Formula",
                  description: "Settings Custom field - Field Details panel Formula title",
                })}
              </TextWithInfo>
            </div>
            <div className={styles.isCalculatedExpression}>{customField.expression}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default FieldDetails;
